/**
 * bidlimit_apply / bidlimit_reservation / bidlimit_click 编辑器：
 * targeting_id=单数字（出价上限），ext_info=marker `bidlimit`（只读）。
 */
import type { EditorProps } from "./types";

export function BidlimitEditor({ item, onChange }: EditorProps) {
  return (
    <div className="flex flex-wrap items-center gap-2">
      <input
        type="number"
        className="leo-input w-40"
        value={item.targeting_id}
        onChange={(e) =>
          onChange({ targeting_id: e.target.value, ext_info: item.ext_info ?? "" })
        }
      />
      <span className="text-[12px] text-text-muted">单位：分</span>
    </div>
  );
}
